module.exports = __webpack_public_path__ + "assets/img/recordIcon8.f9b97271.png";